import { CdpEuiccProfileSetFallbackResponse } from "../app/shared/models/layout/cdp/euicc/profile/set_fallback/CdpEuiccProfileSetFallback";

export function response(): CdpEuiccProfileSetFallbackResponse {
    return {
        cmd: {
            success: true
        }
    }
}
